
export const sizes = (state = [], action) => {
    switch (action.type) {
        case 'ADD_SIZE_ENTRY':
                return [
                    ...state,
                    //{
                    //    articleEntry: action.articleEntry,
                    //    sizes: action.sizes
                    //}
                ]
        default:
            return state
    }
}

export const showSizes = (state = [], action) => {
    console.log("handleChange size showSizes", state, action)
    switch (action.type) {
        case 'SHOW_SIZE_ENTRY':
            return [
                {
                    article: action.articleEntry,
                    sizes: action.sizes
                }
            ]
        default:
            return state
    }
}

export const showSizes2 = (state = [], action) => {
    switch (action.type) {
        case 'SHOW_SIZE_ENTRY2':
            return [
                {
                    article: action.articleEntry,
                    sizes: action.sizes
                }
            ]
        default:
            return state
    }
}

export const addShowedSizes = (state = [], action) => {
    switch (action.type) {
        case 'ADD_SHOW_SIZE_ENTRY':
            return [
                {
                    sizes: [{
                        size: action.size,
                        amount: action.amount
                    }]
                }
            ]
        default:
            return state
    }
}
